import { createHead, type VueHeadClient } from '@unhead/vue/client';

const createSeoHead = (): VueHeadClient => createHead();

export { createSeoHead };
